import { ChangeEvent } from 'react';
import { Translate } from 'next-translate';

import { notification } from '@arkestro/arkestro-design-system';
import Onboard from '@api/corporate/OnboardApi';
import { alertMessage } from '@utils/common';

export const createEventFromFile = (
  file: File,
  t: Translate,
): Promise<unknown> | unknown => {
  if (!file) return Promise.resolve();

  return Onboard.getDocumentParseUrl(file.name, 'event')
    .then(result => {
      if (!result.success) { throw new Error('Failed to get S3 URL from server'); }
      return Onboard.uploadDocumentFileUrl(result.presigned_s3_url, file);
    })
    .then(() => {
      notification.success({
        message: t('rfx_drawer.rff.submit_success'),
        placement: 'bottomRight',
      });
    })
    .catch(() => {
      notification.error({
        message: t('rfx_drawer.rff.submit_error'),
        placement: 'bottomRight',
      });
    });
};

export const createEventFromUpload = (
  event: ChangeEvent<HTMLInputElement>,
  t: Translate,
  cloneEventId: any
): Promise<unknown> | undefined => {
  const fileInput = event.currentTarget;
  const newFile = fileInput.files && fileInput.files[0];

  if (!newFile) return Promise.resolve();

  return Onboard.getDocumentParseUrl(newFile.name, 'event', cloneEventId)
    .then(result => {
      if (!result.success) { throw (new Error('Failed to get S3 URL from server')); }
      const decodedS3URL = result.presigned_s3_url;
      Onboard.uploadDocumentFileUrl(decodedS3URL, newFile)
        .then(() => alertMessage(t('general.file_upload_success_message')))
        .catch(() => {
          alertMessage(t('general.file_upload_error_message'), 'error');
        });
    }).catch(() => {
      alertMessage(t('general.file_upload_error_message'), 'error');
    }).finally(() => {
      // Clean up of file input field
      // eslint-disable-next-line no-param-reassign
      event.target.value = '';
    });
};
